import bathroom from "./bathroom.glb";
import bedroom from "./bedroom.glb";

export const models = { bathroom, bedroom };
